import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import { LoginService } from '../../core/services/login/login.service';
import {
  loginFailed,
  loginReceived,
  loginRequest,
  termsAndConditionsRequest,
} from '../actions/loginAction';
import { CookieService } from '../../core/services/cookie/cookie.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from '../../shared/components/dialog/dialog.component';

@Injectable()
export class loginEffect {
  constructor(
    private actions: Actions,
    private loginService: LoginService,
    private router: Router,
    private cookie: CookieService,
    private dialog: MatDialog,
  ) {}

  loginRequest$ = createEffect(() =>
    this.actions.pipe(
      ofType(loginRequest, termsAndConditionsRequest),
      mergeMap((params) => {
        if (params.type === 'terms-and-conditions-request') {
          return this.loginService.termsAndConditions(params).pipe(
            mergeMap((data: any) => {
              const userData: any = JSON.parse(
                localStorage.getItem('userData') || '',
              );

              // Filter the documents where wasAcknowledged is false, then map to extract the documentName, and join them with commas
              const result = data
                .filter((doc: any) => !doc.wasAcknowledged) // Filter documents with wasAcknowledged as false
                .map((doc: any) => doc.documentName) // Extract documentName from filtered documents
                .join(', ');
              userData.missingUserDocumentAcknowledgment = result;
              localStorage.setItem('userData', JSON.stringify(userData));
              return params.requestType === 'RLRG'
                ? of(
                    loginReceived({ data: userData }),
                    // showPopup({ params: true }),
                  )
                : of(loginReceived({ data: userData }));
            }),
            catchError((error) => of(/* showPopup({ params: false }) */)),
          );
        } else {
          return this.loginService.loginRequest(params.loginParams).pipe(
            map((data) => {
              if (data.changePassword) {
                this.cookie.setItem('sessionHash', data.sessionHash);
                localStorage.setItem(
                  'sessionHash',
                  JSON.stringify(data.sessionHash),
                );
                const dialogRef = this.dialog.open(DialogComponent, {
                  width: '450px',
                  disableClose: true,
                  data: {
                    title: 'Password Change Required',
                    message:
                      'For security reasons, you must change your password before continuing.',
                  },
                });
                dialogRef.afterClosed().subscribe(() => {
                  this.router.navigate(['./create-new-password']);
                });
              } else {
                this.router.navigate(['company-information']);
              }
              this.cookie.setItem('sessionHash', data.sessionHash);
              return loginReceived({ data });
            }),
            catchError((error) => {
              return of(loginFailed({ data: error }));
            }),
          );
        }
      }),
    ),
  );
}
